module.exports = [
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/6324.png',
    alt: '6324.png',
  },
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5872.png',
    alt: '5872.png',
  },
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5916.png',
    alt: '5916.png',
  },
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5873.png',
    alt: '5873.png',
  },
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5877.png',
    alt: '5877.png',
  },
  {
    src: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5914.png',
    alt: '5914.png',
  },
  // {
  //   src: '',
  //   alt: '',
  // },
]



// WEBPACK FOOTER //
// ./src/plugins/partner.js